import React from 'react';
const LongButton = ({ style = {}, type = "normal", icon, onClick, children }) => {
        var bgColor = "gray"
        var textColor= 'white'
        var width = '100%'
        var className = 'cb-button-primary'
    switch(type) {
        case "primary":
        // bgColor = "#378EED"
        textColor= "white"
        style={ ...style}
        break;
        case "action":
        bgColor = "#378EED"
        textColor= "white"
        break;
        case "list":
        bgColor = "transparent"
        textColor= "#49515C"
        className = 'cb-button-list'
        break;
    }
return <div className={`cb-button ${type} ${className}`} style={{width: width,
...style}} 
onClick={e=>onClick()}>{children} {icon}</div>

}

export default LongButton